/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateClientAsAdminRequest
 */
export interface CreateClientAsAdminRequest {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    location: string;
    /**
     * 
     */
    employeeCount: number;
    /**
     * 
     */
    billingCycle: string;
    /**
     * 
     */
    mode: string;
    /**
     * NFR domains are free of charge
     */
    internalAd: boolean;
    /**
     * 
     */
    serviceproviderUUID: string;
    /**
     * Service provider internal client identifier
     */
    clientRef?: string | null;
}

/**
 * Check if a given object implements the CreateClientAsAdminRequest interface.
 */
export function instanceOfCreateClientAsAdminRequest(value: object): value is CreateClientAsAdminRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('employeeCount' in value) || value['employeeCount'] === undefined) return false;
    if (!('billingCycle' in value) || value['billingCycle'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('internalAd' in value) || value['internalAd'] === undefined) return false;
    if (!('serviceproviderUUID' in value) || value['serviceproviderUUID'] === undefined) return false;
    return true;
}

export function CreateClientAsAdminRequestFromJSON(json: any): CreateClientAsAdminRequest {
    return CreateClientAsAdminRequestFromJSONTyped(json, false);
}

export function CreateClientAsAdminRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClientAsAdminRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'location': json['location'],
        'employeeCount': json['employeeCount'],
        'billingCycle': json['billingCycle'],
        'mode': json['mode'],
        'internalAd': json['internalAd'],
        'serviceproviderUUID': json['serviceproviderUUID'],
        'clientRef': json['clientRef'] === undefined ? undefined : json['clientRef'] === null ? null : json['clientRef'],
    };
}

export function CreateClientAsAdminRequestToJSON(json: any): CreateClientAsAdminRequest {
    return CreateClientAsAdminRequestToJSONTyped(json, false);
}

export function CreateClientAsAdminRequestToJSONTyped(value?: CreateClientAsAdminRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'location': value['location'],
        'employeeCount': value['employeeCount'],
        'billingCycle': value['billingCycle'],
        'mode': value['mode'],
        'internalAd': value['internalAd'],
        'serviceproviderUUID': value['serviceproviderUUID'],
        'clientRef': value['clientRef'],
    };
}

